import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import moment from 'moment';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../ui/modal-dialog';
import DropDown from '../ui/react-ui/dropdown';
import Textarea from '../ui/textarea';
import Form from '../ui/form';
import Input from '../ui/input';
import DatePicker from '../ui/react-ui/date-picker';
import Validator from '../../utils/validator'; // api

import { createMessageAPI, editMessageAPI } from '../../api/messageAPI'; // redux

import { clearDialogInfo } from '../../redux/live-message';
var t = i18n.getFixedT(null, 'live-message');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var initMessageData = {
  id: '',
  source: '',
  typeId: '',
  // current harbor is only TWKHH. Call harbor api to select other harbor
  harborId: 'TWKHH',
  harborName: '',
  title: '',
  description: '',
  beginTime: moment().format('YYYY-MM-DD HH:mm'),
  endTime: moment().add(1, 'days').format('YYYY-MM-DD HH:mm'),
  isPublished: false
};
var LiveMessageDraftEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$liveMess = _useSelector.liveMessage,
      _useSelector$liveMess2 = _useSelector$liveMess.dialogInfo,
      mode = _useSelector$liveMess2.mode,
      data = _useSelector$liveMess2.data,
      messageTypeList = _useSelector$liveMess.messageTypeList;

  var dispatch = useDispatch();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(initMessageData),
      _useState4 = _slicedToArray(_useState3, 2),
      formData = _useState4[0],
      setFormData = _useState4[1];

  var id = props.id,
      onClose = props.onClose;
  var form_ref = useRef(null);

  var _API = useRef(null);

  var handleClose = function handleClose() {
    dispatch(clearDialogInfo());
    setFormData(initMessageData);
    setError(null);
  };

  var handleChange = function handleChange(value, path) {
    var newData = _.cloneDeep(formData);

    if (value && path === 'beginTime') {
      if (moment(value).valueOf() > moment(newData.endTime).valueOf()) _.set(newData, 'endTime', value);
    }

    if (value && path === 'endTime') {
      if (moment(value).valueOf() < moment(newData.beginTime).valueOf()) _.set(newData, 'beginTime', value);
    }

    _.set(newData, path, value);

    setFormData(newData);
  };

  var handleConfirm = function handleConfirm() {
    var newFormData = _.cloneDeep(formData);

    if (!newFormData.typeId) return setError(t('txt-select-messageType-required'));
    var fillOutRequired = Validator(['title', 'description'], formData);
    if (fillOutRequired.length > 0) return setError(et('txt-fill-out-required'));
    if (_.isEmpty(newFormData.beginTime) || _.isEmpty(newFormData.endTime)) return setError(t('txt-time-required'));

    _.set(newFormData, 'beginTime', newFormData.beginTime.length === 16 ? newFormData.beginTime + ':00' : newFormData.beginTime);

    _.set(newFormData, 'endTime', newFormData.endTime.length === 16 ? newFormData.endTime + ':00' : newFormData.endTime);

    if (mode === 'messageDraft.create') _.set(newFormData, 'source', 'EVMS');

    _API.current(contextRoot, false, newFormData).then(function (result) {
      setFormData(initMessageData);
      setError(null);
      onClose();
    }).catch(function (error) {
      setError(error.message);
    });
  };

  useEffect(function () {
    if (mode.indexOf('messageDraft') > -1) {
      // confirm edit or create api
      _API.current = mode.indexOf('edit') > -1 ? editMessageAPI : createMessageAPI;
    }

    if (_.isEmpty(mode) || mode.indexOf('messageDraft.edit') < 0) return null;
    setFormData(data);
  }, [mode]);
  if (mode.indexOf('messageDraft') < 0 || mode.indexOf('edit') > -1 && _.isEmpty(formData.id)) return null;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    // disabled: !formValid,
    handler: handleConfirm
  });

  var typeList = _.map(messageTypeList, function (el) {
    return {
      value: el.id,
      text: el.name
    };
  });

  var fields = {};

  _.set(fields, 'typeId', {
    label: t('lbl-message-type'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DropDown, {
        width: '350px',
        defaultText: gt('global.lbl-select'),
        list: typeList,
        onChange: function onChange(val) {
          return handleChange(val, 'typeId');
        },
        value: val ? val : ''
      });
    }
  });

  _.set(fields, 'title', {
    label: t('lbl-message-title'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(Input, {
        value: val ? val : '',
        validate: {
          required: true
        },
        onChange: function onChange(val) {
          return handleChange(val, 'title');
        }
      });
    }
  });

  _.set(fields, 'description', {
    label: t('lbl-message-description'),
    editor: null,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textarea, {
        validate: {
          required: true
        },
        onChange: function onChange(val) {
          return handleChange(val, 'description');
        },
        value: val
      }));
    }
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-start-time'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DatePicker, {
        id: "datetime",
        onChange: function onChange(val) {
          return handleChange(val, 'beginTime');
        },
        enableTime: true,
        value: val // t={(code, params) => {
        //     if (code === 'missing')
        //         return `Please input date`
        //     else {
        //         return `Invalid date format. Should be ${params.pattern}`
        //     }
        // }}

      });
    }
  });

  _.set(fields, 'endTime', {
    label: t('lbl-end-time'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(DatePicker, {
        id: "datetime",
        onChange: function onChange(val) {
          return handleChange(val, 'endTime');
        },
        enableTime: true,
        value: val // t={(code, params) => {
        //     if (code === 'missing')
        //         return `Please input date`
        //     else {
        //         return `Invalid date format. Should be ${params.pattern}`
        //     }
        // }}

      });
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('dlg-create-message-draft'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: formData
  }));
});
LiveMessageDraftEdit.defaultProps = {
  id: 'g-liveMessage-draft-edit'
};
LiveMessageDraftEdit.propTypes = {
  id: PropTypes.string
};
export default LiveMessageDraftEdit;